import React from 'react';
import cx from 'classnames';
import Link from 'next/link';

import Typography from 'components/Typography';
import { Product } from 'types/Product';
import styles from './DownloadTearSheet.module.css';

interface DownloadTearSheetProps {
  product: Product;
  className?: string;
}

const DownloadTearSheet = (props: DownloadTearSheetProps) => {
  const { product, className = '' } = props;

  return (
    <Link href={`/next-api/pdf/product/${product.id}`} rel="noreferrer" target="_blank">
      <Typography block className={cx(styles.root, className)}>
        Download tear sheet
      </Typography>
    </Link>
  );
};

export default DownloadTearSheet;
